import StringParser from '../StringParser';

/* global window */

class General {
	static getPageTitle(pathName, orgName = '') {
		let title = '';

		if (pathName.startsWith('/gallery')) {
			title = 'Galeria';
		}

		return `${StringParser.capitalize(orgName)}${title ? ` - ${title}` : ''}`;
	}

	static getCurrentLocation() {
		return window.location.hostname;
	}

	static getWebName(domain) {
		if (!domain) return null;

		const normalized = domain.toLowerCase();

		if (
			normalized === 'localhost'
			|| normalized === '[::1]'
			|| normalized.endsWith('.localhost')
			|| /^\d+\.\d+\.\d+\.\d+$/.test(normalized)
		) {
			return null;
		}

		if (normalized.endsWith('.roverpix.com')) {
			return normalized.split('.roverpix.com')[0];
		}

		// Custom production domains use the full hostname as web_name
		// (e.g. fotos.photoschool.com.br → fotos.photoschool.com.br).
		return normalized;
	}

	static _getWebNameFromUrl() {
		const params = new URLSearchParams(window.location.search);
		const fromUrl = params.get('web_name');

		if (!fromUrl) return null;

		try { localStorage.setItem('roverpix_web_name', fromUrl); } catch (e) { /* private browsing */ }

		return fromUrl;
	}

	static _getStoredWebName() {
		try { return localStorage.getItem('roverpix_web_name'); } catch (e) { return null; }
	}

	static getWebNameFromCurrentLocation() {
		const domain = General.getCurrentLocation();

		const production = General.getWebName(domain);
		if (production) return production;

		// Only reached on localhost/IP, so the organization has to come from
		// outside the URL: ?web_name= for a one-off test, otherwise
		// ROVERPIX_WEB_NAME in .env.development.local. Never hardcode it.
		return General._getWebNameFromUrl()
			|| process.env.ROVERPIX_WEB_NAME
			|| General._getStoredWebName()
			|| 'fotos';
	}

	static downloadURI(uri, filename) {
		const link = document.createElement("a");
		link.href = uri;
		link.target = '_blank'
		if (filename) link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export default General;
